const collections = {
  cyberKongz: '0x1f7c16fce4fc894143afb5545bf04f676bf7dcf3',
  runiverseLand: '0x775f0a0bb8258501d0862df38a7f7ad8f8f7423d',
  rings: '0x0e5bf9df365f7bf2c9514524ffcbd52b195d1a38',
  runiverseItems: '0x578b65568b7a6a081a477748590774a64d8a4923',
}

export default collections
